// Copyright (c) 2022 by Move Closer

import { ModulesFormRegistryEntry } from '../../../contexts'

import { profileNavFactory } from '../ProfileNav.factory'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (original)
 */
export const profileNavModuleEntry: ModulesFormRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "form/core" */ './ProfileNav.form.vue'),
  factory: profileNavFactory,
  icon: require('../profilenav.svg'),
  label: 'modulesForms.ProfileNav._name'
}
